import { defineStore } from 'pinia'
import {
  ref,
  Ref,
  computed,
  reactive,
} from 'vue'
import { Town } from 'www/vue_components/common/Analyses/types'

const useCommonAnalysesStore = defineStore('commonAnalysesStore', () => {
  const isCategoryPage: Ref<boolean> = ref(false)
  const town = reactive({
    name: '',
    translit: '',
    namePred: '',
  })

  const isAuthPatient = !window.USER.isAnonymous && window.USER.isRealPatient
  const isUserHasPermission = window.USER.isAnonymous || window.USER.isRealPatient
  const useAuthMt = computed(() => !window.IS_YDOC)

  function setTown(newTown: Town) {
    Object.assign(town, newTown)
  }

  return {
    town,
    setTown,
    isAuthPatient,
    isUserHasPermission,
    useAuthMt,
    isCategoryPage,
  }
})

export default useCommonAnalysesStore
